import * as React from 'react';
import {
  List,
  DatagridConfigurable,
  TextField,
  EditButton,
  NumberInput,
  SelectColumnsButton,
  TopToolbar,
  FilterButton,
  CreateButton,
  DateInput, DateField,
  useLocaleState,
  TextInput, FunctionField
} from "react-admin";
import { truncate } from "../helper/truncate";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

const filters = [
    <NumberInput key={0} source="id" label="id" min={1} />,
    <TextInput key={0} source="code" label="code" />,
    <DateInput key={6} source="createdAt#$gte" label="Start Created At" />,
    <DateInput key={7} source="createdAt#$lte" label="End Created At" />,
];

export const ContentList = () => {
  const [locale] = useLocaleState();

  return (
    <List
      filters={filters}
      sort={{ field: 'id', order: 'DESC' }}
      actions={<ListActions />}
    >
      <DatagridConfigurable rowClick="edit" bulkActionButtons={false}>
        <TextField source="id" />
        <TextField source="code" />

        <TextField source={`title.${locale}`} />
        <FunctionField
          label={'Description'}
          render={(record: any) => truncate(record.description[locale], 100)}
        />

        <DateField source="createdAt" showTime locales="lv-LV" />
        <EditButton />
      </DatagridConfigurable>
    </List>
  )
};
